import type { FaireProductEntity } from "../../entity_types/product";

export const p_4fzdmmbtkt: FaireProductEntity = {
  token: "p_4fzdmmbtkt",
  type: "product",
  name: "A Family Of Trees: My First Book Of Forests",
  brandToken: "b_daarv8jc3a",
  brandName: "Phaidon",
  imageUrl:
    "https://cdn.faire.com/fastly/083f7a9e47e566a1fc6eba9f7a0553648979f227496f12074f06518f294eba43.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d3c8e5b8555a8287d6dc586608c39dc7b38802c908050cdb6aba16fe96c54506.webp",
    "https://cdn.faire.com/fastly/f165d6db2b2a20249553d21a8dc6180b17747c2a93bd51e1101312c01f1bd550.webp",
    "https://cdn.faire.com/fastly/c8c2e0653b3c3c85c7691a5433a37bb32b9f85d2731781d9755f596acf008596.webp",
  ],
  priceDollars: 8.48,
  description:
    "A read-aloud, poetic introduction to forests for children aged 2-4 that, when unfolded, creates a forest-scape that is as long as a king-size bed!",
  tags: [],
  isBestseller: true,
  msrpDollars: 16.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
